import React from 'react';
import { Container, FlagButton, FlagText, LoadingText } from './styles';
import { LANGUAGES } from '../../Helpers/translate';

const LanguageSelector = ({ currentLanguage, onLanguageChange, isLoading }) => {
    const languages = Object.values(LANGUAGES);

    return (
        <Container>
            {languages.map(lang => {
                const isActive = currentLanguage === lang.code;
                return (
                    <FlagButton
                        key={lang.code}
                        active={isActive}
                        onPress={() => onLanguageChange(lang.code)}
                        disabled={isLoading}>
                        <FlagText active={isActive}>{lang.flag}</FlagText>
                    </FlagButton>
                );
            })}
            {isLoading && <LoadingText>...</LoadingText>}
        </Container>
    );
};

export default LanguageSelector;
